// extracted by mini-css-extract-plugin
export var backdropBlur = "_gz-0";
export var contentCard = "_gz-5";
export var frame = "_gz-2";
export var image = "_gz-4";
export var imagePane = "_gz-3";
export var modal = "_gz-1";